import _ from "lodash";

// Get DDA Policy
export const getDDAPolicyLoading = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getDDAPolicy", "loading"], false);
export const getDDAPolicyData = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getDDAPolicy", "items"], null);
export const getDDAPolicyStatus = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getDDAPolicy", "status"], false);
export const getDDAPolicyDataData = (item) => _.get(item, ["Data"], null);
export const getDDAPolicyDataPolicyNumber = (item) =>
  _.get(item, ["Policy_Number"], null);
export const getDDAPolicyDataProductName = (item) =>
  _.get(item, ["Product_Name"], null);
export const getDDAPolicyDataAmount = (item) => _.get(item, ["Amount"], null);
export const getDDAPolicyDataStatus = (item) => _.get(item, ["Status"], null);
export const getDDAPolicyDataMsg = (item) => _.get(item, ["Message"], null);
export const getDDAPolicyDataPreferredBankCode = (item) =>
  _.get(item, ["PreferredBankCode", "bankCode"], null);

//Create EDDA
export const createEDDALoading = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["createEDDA", "loading"], false);
export const createEDDAData = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["createEDDA", "items"], null);
export const createEDDAStatus = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["createEDDA", "status"], false);
export const createEDDADataData = (item) => _.get(item, ["Data"], null);
export const createEDDADataDataInside = (item) => _.get(item, ["data"], null);
export const createEDDADataDataInsideErrorMsg = (item) =>
  _.get(item, ["Error_Messsage"], null);
export const createEDDADataDataInsideErrorCode = (item) =>
  _.get(item, ["Error_Code"], null);
export const createEDDADataErrorMessage = (item) =>
  _.get(item, ["ErrorMessage"], null);
export const createEDDADataSuccess = (item) => _.get(item, ["Success"], null);
export const createEDDADataResult = (item) =>
  _.get(item, ["RedirectUrl"], null);

//Get GIRO Bank List
export const getGIROBankListLoading = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getGIROBankList", "loading"], false);
export const getGIROBankListData = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getGIROBankList", "items"], null);
export const getGIROBankListStatus = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getGIROBankList", "status"], false);
export const getGIROBankListDataSuccess = (item) =>
  _.get(item, ["Success"], null);
export const getGIROBankListDataMsg = (item) => _.get(item, ["Message"], null);
export const getGIROBankListDataData = (item) => _.get(item, ["Data"], null);

//Get GIRO CALL BACK DATA
export const getGiroCallBackDataLoading = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getGIROCallBackData", "loading"], false);
export const getGiroCallBackData = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getGIROCallBackData", "items"], null);
export const getGiroCallBackDataStatus = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getGIROCallBackData", "status"], false);
export const getGiroCallBackDataData = (item) => _.get(item, ["Data"], null);
export const getGiroCallBackDataBankAccountNo = (item) =>
  _.get(item, ["Bank_Account_No"], null);
export const getGiroCallBackDataDDAReferenceNo = (item) =>
  _.get(item, ["DDA_Reference_No"], null);
export const getGiroCallBackDataTransactionReferenceNo = (item) =>
  _.get(item, ["Transaction_Reference_No"], null);
export const getGiroCallBackDataIsThirdParty = (item) =>
  _.get(item, ["Is_Third_Party"], null);
export const getGiroCallBackDataOrderNumber = (item) =>
  _.get(item, ["Order_Number"], null);
export const getGiroCallBackDataRenewalPremium = (item) =>
  _.get(item, ["Renewal_Premium"], null);
export const getGiroCallBackStatus = (item) => _.get(item, ["Status"], null);
export const getGiroCallBackDataErrorCode = (item) =>
  _.get(item, ["Error_Code"], null);
export const getGiroCallBackDataErrorMessage = (item) =>
  _.get(item, ["Error_Message"], null);

//Get GIRO CALL BACK exist
export const getGiroCallBackExistLoading = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getGIROCallBackExist", "loading"], false);
export const getGiroCallBackExistData = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getGIROCallBackExist", "items"], null);
export const getGiroCallBackExistStatus = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getGIROCallBackExist", "status"], false);
export const getGiroCallBackExistDataData = (item) =>
  _.get(item, ["Data"], null);
export const getGiroCallBackDataStatusStatus = (item) =>
  _.get(item, ["Status"], null);
export const getGiroCallBackDataRedirectUrl = (item) =>
  _.get(item, ["RedirectUrl"], null);

//submit giro
export const submitGiroLoading = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["submitGiro", "loading"], false);
export const submitGiroData = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["submitGiro", "items"], null);
export const submitGiroStatus = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["submitGiro", "status"], false);
export const submitGiroDataSuccess = (item) => _.get(item, ["Success"], null);
export const submitGiroDataData = (item) => _.get(item, ["Data"], null);
export const submitGiroDataRedirectUrl = (item) =>
  _.get(item, ["RedirectUrl"], null);

//Get GIRO Submit CALL BACK exist
export const getGiroSubmitCallBackExistLoading = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getGIROSubmitCallBackExist", "loading"], false);
export const getGiroSubmitCallBackExistData = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getGIROSubmitCallBackExist", "items"], null);
export const getGiroSubmitCallBackExistStatus = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["getGIROSubmitCallBackExist", "status"], false);
export const getGiroSubmitCallBackExistDataData = (item) =>
  _.get(item, ["Data"], null);
export const getGiroSubmitCallBackExistDataStatus = (item) =>
  _.get(item, ["Status"], null);
export const getGiroSubmitCallBackExistDataRedirectUrl = (item) =>
  _.get(item, ["RedirectUrl"], null);
export const getGiroSubmitCallBackExistDataGiroFlow = (item) =>
  _.get(item, ["GiroFlow"], null);

//Enrol eGiro
export const enroleGiroLoading = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["enroleGiro", "loading"], false);
export const enroleGiroData = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["enroleGiro", "items"], null);
export const enroleGiroStatus = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["enroleGiro", "status"], false);
export const enroleGiroDataData = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["enroleGiro", "Data"], false);
export const enroleGiroDataDataStatus = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["enroleGiro", "Status"], false);

//Confirm Pay Edda Gi Renewal
export const confirmPayEddaGiRenewalLoading = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["confirmPayEddaGiRenewal", "loading"], false);
export const confirmPayEddaGiRenewalData = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["confirmPayEddaGiRenewal", "items"], null);
export const confirmPayEddaGiRenewalStatus = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["confirmPayEddaGiRenewal", "status"], false);
export const confirmPayEddaGiRenewalDataData = (item) =>
  _.get(item, ["Data"], null);
export const confirmPayEddaGiRenewalDataStatus = (enrolGIRONow) =>
  _.get(enrolGIRONow, ["Status"], false);
export const confirmPayEddaGiRenewalDataRenewalFlow = (item) =>
  _.get(item, ["RenewalFlow"], null);
